import { AbstractClientPermissionService } from "@cervval.js/client-permissions";
import { PERMISSION_SERVICE, Permission, deserializePermission } from "@cervval.js/common-permissions";
import { Injectable } from "@cervval.js/common/src/dependencies/injectable";
import { AppPermissionContext, getUserRoles } from "@sportsante/common-shared/src/data/global/permission.tools";
import { AppLoginData } from "@sportsante/common-shared/src/data/users/appLoginData";

@Injectable(PERMISSION_SERVICE)
export class AppClientPermissionService extends AbstractClientPermissionService<AppLoginData, AppPermissionContext> {

    /** @inheritdoc */
    public override getPermissionContext = (): AppPermissionContext => {
        return {
            //
        };
    };

    /**
     * TODO comment and refactor
     */
    public override getMergedPermissions(loginData: AppLoginData, permissionContext?: AppPermissionContext): Permission[] {
        // TODO cache
        const roles = getUserRoles(loginData, permissionContext);
        return roles.flatMap((r) => r.permissions).map(deserializePermission);
    }

    /**
     * @returns true is current user has the permission(s) for provided context or current context if none provided
     */
    public has(p: {
        //
    }, permissionContext?: AppPermissionContext): boolean {
        return false;
    }

}
